import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FiArrowRight,
  FiLock,
  FiShield,
  FiFileText,
  FiCheckCircle,
  FiTrendingUp,
} from "react-icons/fi";
import TermsModal from "./TermsModal";

import logo from "../../Images/buillogo7.png";
import Company_Logo from "../../Images/OGGS_Logo.png";
import bgImg from "../../Images/bgImg.jpg";

const HomePage = () => {
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(false);

  const year = useMemo(() => new Date().getFullYear(), []);

  const openTermsModal = () => setModalOpen(true);
  const closeTermsModal = () => setModalOpen(false);

  const handleSellerLogin = () => navigate("/sign-in");
  const handleTerms = () => navigate("/sales-with-ogcs");

  return (
    <div className="relative min-h-screen w-full font-sans bg-slate-50 overflow-hidden">

      {/* Background */}
      <div className="absolute inset-0">
        <div
          className="absolute inset-0 bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${bgImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />

        <div className="absolute inset-0 bg-gradient-to-b from-white/70 via-white/55 to-slate-50/85" />
      </div>

      {/* Page Content */}
      <div className="relative z-10 min-h-screen flex flex-col">

        {/* Navbar */}
        <nav
          className="w-full text-white"
          style={{ backgroundColor: "#1e74cb" }}
        >
          <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">

            <div className="flex items-center gap-3">
              <img
                src={logo}
                alt="BuildPro Logo"
                className="w-20 md:w-24"
              />

              <div>
                <h2 className="text-lg md:text-2xl font-extrabold">
                  BuildPro OGCS
                </h2>
                <p className="text-xs text-white/80 font-semibold">
                  Building Supplies at Your Fingertips
                </p>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <img
                src={Company_Logo}
                alt="OGCS Logo"
                className="h-10 md:h-12"
              />

              <button
                onClick={handleSellerLogin}
                className="hidden sm:flex items-center gap-2 h-10 px-4 rounded-xl bg-white text-slate-900 font-bold hover:bg-white/90"
              >
                Seller Login
                <FiArrowRight />
              </button>
            </div>
          </div>
        </nav>

        {/* Main Hero */}
        <main className="flex-1 flex items-center justify-center px-4">

          <div className="max-w-3xl w-full rounded-3xl border border-white/40 bg-white/85 backdrop-blur p-8 shadow-lg text-center">

            {/* Tags */}
            <div className="flex justify-center flex-wrap gap-2">

              <span className="flex items-center gap-2 bg-blue-50 border border-blue-100 px-3 py-1 rounded-full text-blue-800 text-xs font-bold">
                <FiShield /> Trusted Platform
              </span>

              <span className="flex items-center gap-2 bg-green-50 border border-green-100 px-3 py-1 rounded-full text-green-800 text-xs font-bold">
                <FiCheckCircle /> Verified Sellers
              </span>

              <span className="flex items-center gap-2 bg-orange-50 border border-orange-100 px-3 py-1 rounded-full text-orange-700 text-xs font-bold">
                <FiTrendingUp /> Fast Growth
              </span>

            </div>

            {/* Heading */}
            <h1 className="mt-6 text-4xl font-extrabold text-slate-900">
              Welcome to <span className="text-blue-700">BuildPro OGCS</span>
            </h1>

            <p className="mt-4 text-slate-600">
              A modern platform for construction procurement.  
              Connect with verified suppliers, list your products, and grow your business faster.
            </p>

            {/* CTA Buttons */}
            <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">

              <button
                onClick={handleSellerLogin}
                className="flex items-center justify-center gap-2 px-6 h-12 bg-orange-500 text-white font-bold rounded-xl hover:bg-orange-600"
              >
                Register / Login
                <FiArrowRight />
              </button>

              <button
                onClick={handleTerms}
                className="flex items-center justify-center gap-2 px-6 h-12 bg-green-600 text-white font-bold rounded-xl hover:bg-green-700"
              >
                <FiFileText />
                Terms & Conditions
              </button>

              <button
                onClick={openTermsModal}
                className="flex items-center justify-center gap-2 px-6 h-12 bg-white border rounded-xl font-bold hover:bg-gray-50"
              >
                <FiLock />
                Privacy Policy
              </button>

            </div>

          </div>

        </main>

        {/* Footer */}
        <footer className="border-t bg-white/70 backdrop-blur">

          <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col sm:flex-row justify-between">

            <p className="text-xs text-slate-600">
              © {year} OGCS Private Limited. All rights reserved.
            </p>

            <div className="flex gap-3">
              <button
                onClick={openTermsModal}
                className="text-xs font-bold hover:underline"
              >
                Privacy Policy
              </button>

              <button
                onClick={handleTerms}
                className="text-xs font-bold hover:underline"
              >
                Terms & Conditions
              </button>
            </div>

          </div>

        </footer>

        <TermsModal isOpen={isModalOpen} onClose={closeTermsModal} />

      </div>
    </div>
  );
};

export default HomePage;